export default {

    namespaced: true,

    state: {
        schoolTypes: [
            {
                code: "primary",
                name: "Primary School"
            },
            {
                code: "juniorHighSchool",
                name: "Junior High School"
            },
            {
                code: "seniorHighSchool",
                name: "Senior High School"
            }
        ],
        subscriptionTypes: [
            {
                code: "basic",
                name: "Basic Package"
            },
            {
                code: "plus",
                name: "Plus Package"
            },
            {
                code: "premium",
                name: "Premium Package"
            }
        ],
        paymentPlans: [
            {
                code: "monthly",
                name: "Monthly Payment Plan"
            },
            {
                code: "quarterly",
                name: "Quarterly Payment Plan"
            },
            {
                code: "yearly",
                name: "Yearly Payment Plan"
            }
        ]                
    },

    getters: {
        schoolTypes: state => state.schoolTypes,
        subscriptionTypes: state => state.subscriptionTypes,
        paymentPlans: state => state.paymentPlans,
    },

    mutations: {

    },

    actions: {

    }

}